import { useStripe, useElements, CardElement,Elements } from "@stripe/react-stripe-js";
import { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { updateAuth } from "../store/Reducers/authReducer"; // Adjust the import as needed
import { useReduxStore } from "../hooks/useReduxStore"; // Adjust the import as needed
import * as PaymentService from "../services/paymentService"; // Adjust the import as needed
import { stripeAPIKey } from "../Constant/Data";

const CheckoutForm = ({ amount = 10, id, handelModalType,onClose }) => {
  const stripe = useStripe();
  const elements = useElements();
  const { dispatch, getState } = useReduxStore();
  const { userData } = getState("AUTH");
  const { email, name } = userData || {};
  const [errorMessage, setErrorMessage] = useState("null");
  const [isEmpty, setIsEmpty] = useState(true);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [recaptchaError, setRecaptchaError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpMessage, setOtpMessage] = useState("");
  const [resendVisible, setResendVisible] = useState(false);
  const [resendVisible1, setResendVisible1] = useState(false);

  const onChangeCard = (obj) => {
    setErrorMessage(obj?.error?.message);
    setIsEmpty(obj?.empty);
  };

  

  const handleRecaptcha = (token) => {
    setRecaptchaToken(token);
    setRecaptchaError(null);
  };

  const isFormValid = () => {
    return !isEmpty && !errorMessage 
  };

  const CloseModal = () => {
    if (errorMessage === "OTP verified successfully") {
      setIsModalOpen(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
 console.log("chala----")
    try {
      if (elements == null) return;

      let elementError = await elements.submit();
      const { error: submitError } = elementError;
      if (submitError) return;
     onClose()
      handelModalType("loading");
      // dispatch(updateAuth({ loading: true }));

      let { ok, data,originalError } = await PaymentService.createIntent({
        // amount,
        // name,
        // email,
        // recaptchaToken,
      });
      console.log("createIntent-----",data?.clientSecret)
      const {clientSecret: intent, amount: intentAmount } = data || {};

      if (ok && intent) {
        const confirmCardPaymentRes = await stripe.confirmCardSetup(data?.clientSecret, {
          payment_method: {
            card: elements.getElement(CardElement),
            billing_details:{
              name:userData?.name,
              email:userData?.email
            }
          },
          
        });
        console.log("confirmCardPaymentRes-------",confirmCardPaymentRes)
const {error ,setupIntent
}=confirmCardPaymentRes
        if (error) {
          handelModalType("failed",error.message);
          setErrorMessage(error.message);
        } else {
          let { ok,data } = await PaymentService.paymentSuccess({
            planId: id,
            paymentMethodId:setupIntent?.payment_method,
            // payment_intent: intent,
            // intent_amount: intentAmount,
          });
          console.log("Data-------",data)
          if (ok) {
            handelModalType("success");
            dispatch(updateAuth({subscription:[{...data?.subscription||{}}]}))
          } else {
            handelModalType("failed",data?.error);
          }
        }
      } else {
        console.log("failed------")
        handelModalType("failed",data?.message||originalError?.message);
      }
    } catch (error) {
      console.log("error-----",error)
      handelModalType("failed",);
    } finally {
      dispatch(updateAuth({ loading: false }));
    }
  };

  const handleVerifyOtp = async () => {
    try {
      const response = await fetch(
        "https://admin.bab-media.com/public/api/payment/otp/verify",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userData?.token}`,
          },
          body: JSON.stringify({ otp }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to verify OTP");
      }

      const result = await response.json();
      setIsModalOpen(false);
      if (result.ok) {
        setErrorMessage("OTP verified successfully");
      } else {
        throw new Error(
          result.message || "Unknown error during OTP verification"
        );
      }
    } catch (error) {
      setErrorMessage(error.message);
    }
  };

  const handleResendOtp = async () => {

    try {
      const response = await fetch(
        "https://admin.bab-media.com/public/api/payment/otp/resend",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userData?.token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to resend OTP");
      }
      setResendVisible1(true)
      setOtpMessage(
        "An OTP has been resent to your email. It will expire within 5 minutes."
      );
      setTimeout(()=>{
        setResendVisible1(false)
      },120000)
    } catch (error) {
      setErrorMessage(error.message);
    }
  };

  const handleContinue = async () => {
    setTimeout(() => {
      setResendVisible(true);
    }, 300000);
    try {
      const response = await fetch(
        "https://admin.bab-media.com/public/api/payment/otp/generate",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userData?.token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to send OTP");
      }

      setIsModalOpen(true);
    } catch (error) {
      setErrorMessage(error.message);
    }
  };

  const cardElementOptions = {
    style: {
      base: {
        fontSize: '16px',
        color: '#ffffff',
        '::placeholder': {
          color: '#9ca3af',
        },
        backgroundColor: '#384355',
        padding: '12px',
        borderRadius: '8px',
        border: '1px solid #4A5567',
      },
      invalid: {
        color: '#ef4444',
        iconColor: '#ef4444',
      },
    },
    hidePostalCode: false,
  };

  return (
      <div>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-sm font-medium text-white mb-2">
            Card Information
          </label>
          <div className="p-3 bg-[#384355] border border-borderGray rounded-lg">
            <CardElement 
              onChange={onChangeCard} 
              options={cardElementOptions}
            />
          </div>
          {errorMessage && errorMessage !== "null" && errorMessage !== "OTP verified successfully" && (
            <p className="mt-2 text-sm text-red-400">{errorMessage}</p>
          )}
        </div>

        {errorMessage === "OTP verified successfully" ? (
          <button
            type="button"
            onClick={handleSubmit}
            className="block mt-8 w-full mx-auto bg-primaryBlue hover:bg-primaryBlue/90 text-white rounded-lg px-3 py-2 font-semibold transition-colors"
          >
            PAY NOW
          </button>
        ) : (
          <button
            type="button"
            onClick={handleSubmit}
            className={`block mt-8 w-full mx-auto ${
              isFormValid()
                ? "bg-primaryBlue hover:bg-primaryBlue/90"
                : "bg-gray-600 cursor-not-allowed"
            } text-white rounded-lg px-3 py-2 font-semibold transition-colors`}
            disabled={!isFormValid()}
          >
            CONTINUE
          </button>
        )}
      </form>

    

    </div>
  );
};

export default CheckoutForm;
